import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { CommonService } from './services/common.service';
import { SvgIconRegistryService } from 'angular-svg-icon';
import {PrimeNG} from "primeng/config";

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
})
export class AppComponent implements OnInit {

  loaderVisibility = false;

  constructor(private commonService: CommonService,
              private svgService: SvgIconRegistryService,
              private changeDetectionRef: ChangeDetectorRef,
              private primeNGConfig: PrimeNG) { }

  ngOnInit(): void {
    this.primeNGConfig.setTranslation({
      dayNames: ['Воскресенье', 'Понедельник', 'Вторник', 'Среда', 'Четверг', 'Пятница', 'Суббота'],
      dayNamesShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
      dayNamesMin: ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'],
      monthNames: [ 'Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь' ],
      monthNamesShort: [ 'Янв', 'Фев', 'Мар', 'Апр', 'Май', 'Июн', 'Июл', 'Авг', 'Сен', 'Окт', 'Ноя', 'Дек' ],
      today: 'Сегодня',
      clear: 'Очистить',
      weekHeader: 'Нд'
    });

    // Preloading svg icons
    this.svgService.loadSvg('/assets/images/icon_cart.svg', 'cart')?.subscribe();
    this.svgService.loadSvg('/assets/images/icon_spinner.svg', 'spinner')?.subscribe();
		this.svgService.loadSvg('/assets/images/icon_eye.svg')?.subscribe();
		this.svgService.loadSvg('/assets/images/icon_eye_slash.svg')?.subscribe();

    // Subscribing to full page loader flag
    this.commonService.getFullPageLoaderVisibility()
      .subscribe(visibility => {
        this.loaderVisibility = visibility;
        this.changeDetectionRef.detectChanges();
      });

  }

}
